const isItMyTurn = (checkersCount, role) => {
  if (
    (checkersCount % 2 === 0 && role === "player1") ||
    (checkersCount % 2 !== 0 && role === "player2")
  )
    return true;
  return false;
};

export default isItMyTurn;
